export default __webpack_public_path__ + "static/media/logo_v2.7c8d0ac8.svg";